import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocApiKeyManagementRoute } from '@jira/router-routes__eoc-api-key-management-routes/src/eocApiKeyManagementRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources } from '@atlassian/eoc-api-key-management/resources';
import type { Route } from '@atlassian/react-resource-router';
import APIKeyManagementPage, { LazyApiKeyManagement } from './ui/index.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const eocApiKeyManagementRouteEntry: Route = createEntry(eocApiKeyManagementRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: APIKeyManagementPage,
	layout: opsSettingsLayout,

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		...resources(),
	],

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyApiKeyManagement],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
